import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { PROPERTIES } from '../constants';
import SubmissionsAppLink from 'FormsUI/components/common/SubmissionsAppLink';
import { jsx as _jsx } from "react/jsx-runtime";
function SubmissionsCell({
  crmObject
}) {
  const propertyValue = getPropertyValue(crmObject, PROPERTIES.SUBMISSIONS);
  const submissionsCount = Number(propertyValue);
  const formId = getPropertyValue(crmObject, PROPERTIES.FORM_ID);
  return /*#__PURE__*/_jsx(SubmissionsAppLink, {
    formId: formId,
    use: "blue",
    onClick: () => trackDashboardInteraction('view-submissions', {
      via: 'table'
    }),
    children: /*#__PURE__*/_jsx(FormattedNumber, {
      value: submissionsCount || 0,
      abbreviate: true
    })
  });
}
export const submissions = {
  width: 160,
  multiline: true,
  renderCell: props => /*#__PURE__*/_jsx(SubmissionsCell, Object.assign({}, props))
};